export const MODULE_ONLY = 'MODULE_ONLY';
export const FULL_CONTENT = 'FULL_CONTENT';